// constants.ts

export const NAME = 'allAdmins';